// Task status options
export const TODO_STATUS = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  DONE: 'Done',
};

export const TODO_STATUS_OPTIONS = [
  TODO_STATUS.NOT_STARTED,
  TODO_STATUS.IN_PROGRESS,
  TODO_STATUS.DONE,
];

// Timeframe filter keys
export const TIMEFRAME = {
  ALL: 'all',
  OVERDUE: 'overdue',
  THIS_WEEK: 'thisWeek',
  NEXT_WEEK: 'nextWeek',
  NEXT_MONTH: 'nextMonth',
  LATER: 'later',
};

// Status filter keys
export const STATUS_FILTER = {
  ALL: 'all',
  ACTIVE: 'active',
  COMPLETED: 'completed',
};

// Sort options
export const SORT_BY = {
  MEETING: 'meeting',
  TOPIC: 'topic',
  ASSIGNEE: 'assignee',
  FIRST_NAME: 'firstName', 
  LAST_NAME: 'lastName',
};

// View names
export const VIEW = {
  DASHBOARD: 'dashboard',
  MY_TODOS: 'my-todos',
  MEETING_DETAIL: 'meeting-detail',
  ACTIVE_SESSION: 'active-session',
  ALL_TODOS: 'all-todos',
  ALL_TOPICS: 'all-topics',
  USERS: 'users',
  MEETINGS: 'meetings',
};

export default {
  TODO_STATUS,
  TODO_STATUS_OPTIONS,
  TIMEFRAME,
  STATUS_FILTER,
  SORT_BY,
  VIEW,
};
